import React, { useEffect } from "react";
import { useModal, useApp } from "../_contexts";
import { Button, Icon } from "../_components";

export function EmptyChronicle({ editor, chronicle }) {
  const { openModal } = useModal();
  const { editMode } = useApp();

  const handleSetupClick = (ev) => {
    openModal("intro");
  };

  useEffect(() => {
    if (editor && chronicle && !chronicle.setupComplete && editMode) {
      openModal("intro");
    }
  }, [editMode, editor, chronicle]);

  return (
    <div className="chronos-empty-chronicle-display">
      <h1>New Chronicle</h1>
      <p className="text-muted">
        Welcome! This Chronicle doesn't have any content yet!
      </p>
      {editor && !chronicle.setupComplete && editMode && (
        <div className="chronos-editor-options">
          <p>
            If you're seeing this, you should click the button below to get
            started!
          </p>
          <Button onClick={handleSetupClick} color="primary">
            <Icon icon="far fa-play fa-fw" />
            &nbsp;Get Started
          </Button>
        </div>
      )}
    </div>
  );
}
